import { Flex } from "@chakra-ui/react"

export const UserInfoWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ columnGap: 4, rowGap: 2, flexWrap: 'wrap' }}>{children}</Flex>
}

export const UserInfo = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ gap: 2, flexWrap: 'wrap' }}>{children}</Flex>
}